/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartAuto = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m13.172 6.586 4.242 4.242-4.242 4.244-7.344 7.342-4.242-4.242 8.757-8.758zM20 16v2h2v2h-2v2h-2v-2h-2v-2h2v-2zm-9.657-3.758-5.929 5.929 1.414 1.414 5.929-5.929zm2.828-2.828-1.414 1.413 1.414 1.415 1.414-1.414zM6 2v2h2v2H6v2H4V6H2V4h2V2zm14 0v2h2v2h-2v2h-2V6h-2V4h2V2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartAuto as ChartAuto };
